import React from 'react';
import { useI18n } from './useI18n';

export const LanguageToggle = () => {
  const { lang, setLang, t } = useI18n();
  return (
    <div className="langToggle" role="group" aria-label={t('lang.aria')}>
      <button
        className={lang === 'zh' ? 'langToggleButton activeLangToggleButton' : 'langToggleButton'}
        onClick={() => setLang('zh')}
      >
        {t('lang.toggle.zh')}
      </button>
      <button
        className={lang === 'en' ? 'langToggleButton activeLangToggleButton' : 'langToggleButton'}
        onClick={() => setLang('en')}
      >
        {t('lang.toggle.en')}
      </button>
    </div>
  );
};
